import React from "react";
import { useSelector } from "react-redux";
import { LanguageLoader } from '../../../assets/languages/index.js';
import Select from 'react-select';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';
import { Toastify, DownloadByContent } from '../../../components/utils/index.js';
import api from "../../../services/axios.js";
import { config } from "../../../services/config.js";
import DatePicker from "react-multi-date-picker";
import persian_fa from "react-date-object/locales/persian_fa";
import persian from "react-date-object/calendars/persian";
import Attachments from "../../../components/features/Attachments.jsx";
import Modal from '../../../components/features/Modal.jsx';
import { DownloadFileAPI } from "../../../services";

const CreateProduct_Request = () => {
	const preferences = useSelector((state) => state.preferences);
	const language = LanguageLoader(preferences.language);
	const [dataEntry, SetDataEntry] = useState([]);
	const [searchParams] = useSearchParams();
	const workorder_id = searchParams.get("workorder_id");
	const id = searchParams.get("id");
	const [serviceMethod, SetServiceMethod] = useState("Guarantee");
	const [partType, SetPartType] = useState("part");
	const [date, SetDate] = useState();
	const [description, SetDescription] = useState();
	const [attachments, SetAttachment] = useState([]);
	const [selectedParts, setSelectedParts] = useState([]);
	const [showPartsTable, setShowPartsTable] = useState(false);
	const [showAosProductModal, setAosProductModal] = useState(false);
	const [hideAosProductModal, setAosProductFallDownModal] = useState(false);
	const [aosProductSearch, SetAosProductSearch] = useState(null);
	const [aosProductSearchResult, SetaosProductSearchResult] = useState();
	const [assetSerialNumber, SetAssetSerialNumber] = useState('');
	const [requestNumber, setRequestNumber] = useState('');
	const [status, setStatus] = useState('');
	const [typingTimeout, setTypingTimeout] = useState(null);
	const navigate = useNavigate();
	const [loading, setLoading] = useState(true);

	// Function to map status values to Persian labels
	const getStatusLabel = (statusValue) => {
		const statusMap = {
			'Pending': 'درحال بررسی',
			'Approved': 'تایید شده',
			'Suspended': 'تعلیق شده',
			'Cancelled': 'ابطال شده',
			'Not_Approved': 'تایید نشده'
		};
		return statusMap[statusValue] || statusValue;
	};

	useEffect(() => {
		if (id){
			FetchProductRequestById(id);
		}
	}, [searchParams]);

	const FetchProductRequestById = async (id) =>{
		try{
			const method = 'FetchProductRequestById';
			const data = {
				id:id,
			};
			const APIResponse = await api.post(
				config.api + '?method=' + method,
				JSON.stringify(data)
			);
			const resp = APIResponse?.data || APIResponse;
			// Populate form fields with fetched data
			if (resp) {
				// Set requester name
				if (resp.name) {
					SetDataEntry(prev => ({ ...prev, service_man: resp.name }));
				}
				
				// Set base document (serviceman)
				if (resp.serviceman) {
					SetDataEntry(prev => ({ ...prev, name: resp.serviceman }));
				}
				
				// Set request number
				if (resp.number) {
					setRequestNumber(resp.number);
				}
				
				// Set status
				if (resp.status) {
					setStatus(getStatusLabel(resp.status));
				}
				
				if (resp.warranty === 'warranty') {
					SetServiceMethod('Guarantee');
				} else {
					SetServiceMethod('Non_Guarantee');
				}
				
				SetPartType(resp.part_type || 'part');
				SetDate(resp.date);
				SetDescription(resp.description || '');
				
				// Set attachments
				if (resp.attachments && Array.isArray(resp.attachments)) {
					SetAttachment(resp.attachments);
				}
				
				if (resp.selectedParts && Array.isArray(resp.selectedParts)) {
					setSelectedParts(resp.selectedParts.map(part => ({
						...part,
						count: parseInt(part.number) || 1,
						checked: true
					})));
					setShowPartsTable(true);
				}
			}
			setLoading(false);
		}catch{
			setLoading(false);
		}
	}
	const DoSave = async () => 
	{
		if(!date || date.length === 0)
		{
			Toastify("تاریخ انجام کار الزامی است");
			return;
		}
		const data = {
			serviceman_id: dataEntry['serviceman_id'],
			selectedParts: selectedParts,
			part_type: partType,
			date_needed: convertPersianToEnglishDigits(date),
			work_order_id: workorder_id,
			serviceMethod: serviceMethod,
			description: description,
			attachments: attachments
		};
		const method = "createProductRequest";
		const APIResponse = await api.post(
		config.api + "?method=" + method,
		JSON.stringify(data)
		);
		if (APIResponse.result == true)
		{
			navigate(`/detail/Product_Request/${APIResponse.id}`);
		}
	};

	function convertPersianToEnglishDigits(str) {
		return str.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
	}

	const GetWorkOrder = async () => {
		const response = await api.get(config.api + `?method=GetWorkOrder&workorder_id=${workorder_id}`);
		SetDataEntry(response);
		// Set initial selected parts from productRequest.data if available
		if (response?.productRequest?.data && Array.isArray(response.productRequest.data)) {
			setSelectedParts(response.productRequest.data.map(item => ({
				...item,
				count: parseInt(item.qty_required) || 1, // default count from qty_required
				checked: true // default checked
			})));
			setShowPartsTable(true);
		}
		setLoading(false);
	};

	useEffect(() => {
		if (workorder_id)
		{
			GetWorkOrder();
		}
	}, [workorder_id]);
	
	const serviceOptions = [
		{ value: 'Guarantee', label: 'گارانتی' },
		{ value: 'Non_Guarantee', label: 'غیر گارانتی' },
	];

	const partTypeOptions = [
		{ value: 'part', label: 'قطعه' },
		{ value: 'material', label: 'مواد مصرفی' },
		{ value: 'changeable', label: 'تعویضی' },
	];

	const attachmentDrop= {
		image: 'فایل ضمیمه',
	}; 

	const HandleAttachment = (value) => {
		SetAttachment(value);
	};

	const selectedOption = 'option';

	const selectPartAos = async (index) => {
		const selectedItem = aosProductSearchResult[index];
		setSelectedParts(prev => {
			const exists = prev.some(p => p.id === selectedItem.id);
			if (!exists) {
				setShowPartsTable(true);
				// Add default values: count: 1, checked: true
				return [...prev, { ...selectedItem, count: 1, checked: true }];
			}
			return prev;
		});
	};

	const CalculatePolicies = async () => {
		const data = {
			customerId: dataEntry?.[0]?.id || undefined,
			// Serialize date as formatted string for backend
			date: date,
			lineItems: selectedParts,
			ModuleName : "Work_Orders"
		};
		const method = "getCalculatePoliciesRahkaran";
		const APIResponse = await api.post(
		config.api + "?method=" + method,
		JSON.stringify(data)
		);
	}

	const handleSearchAosProduct = async (ProductListSearch)=>
	{
		if(ProductListSearch.length < 1)
		{
			return;
		}
		const data = {
			ProductListSearch: ProductListSearch,
			assetId: dataEntry[0]?.assetId ?? null,
			workType: selectedOption,
			assetSerialNumber: assetSerialNumber,
		};
		const method = 'ProductList';
		const APIResponse = await api.post(
			config.api + '?method=' + method,
			JSON.stringify(data)
		);
		SetaosProductSearchResult(APIResponse.data);
	}

	const handleLiveSearch = (value) => {
		SetAosProductSearch(value);
		if (typingTimeout) {
			clearTimeout(typingTimeout);
		}
		if (value && value.length > 3) {
			const timeout = setTimeout(() => {
				handleSearchAosProduct(value);
			}, 300);
			setTypingTimeout(timeout);
		}
	}
	return <>
		<div className='title flex justify-between w-full'>
			<h6>درخواست کالا و قطعات</h6>
			<div className="flex">
				<button onClick={() => navigate(-1)}  type="button" className='btn btn-secondary' >
					بازگشت
				</button>
				{!id && (
					<button onClick={DoSave} type="button" className='btn btn-primary'>
						{language.SAVE}
					</button>
				)}
			</div>
		</div>
		<div className="flex flex-wrap">
			{id && (
				<div className="Field_Container">
					<div className="flex">
						<label>
							شماره درخواست
						</label>
					</div>
					<input
						type="text"
						className="form-control"
						disabled
						value={requestNumber}
					/>
				</div>
			)}
			{id && (
				<div className="Field_Container">
					<div className="flex">
						<label>
							وضعیت
						</label>
					</div>
					<input
						type="text"
						className="form-control"
						disabled
						value={status}
					/>
				</div>
			)}
			<div className="Field_Container">
				<div className="flex">
					<label>
						درخواست کننده<span className="text-danger">*</span>
					</label>
				</div>
				<input
					type="text"
					className="form-control"
					disabled
					value={dataEntry?.service_man || ''}
				/>
			</div>
			<div className="Field_Container">
				<div className="flex">
					<label>
						وضعیت گارانتی<span className="text-danger">*</span>
					</label>
				</div>
				<Select
					options={serviceOptions}
					value={serviceOptions.find(option => option.value === serviceMethod)}
					onChange={(selectedOption) => SetServiceMethod(selectedOption.value)}
					inputId="type-select"
					className="vision-select-container"
					classNamePrefix="vision-select"
					isDisabled={!!id}
				/>
			</div>
			<div className="Field_Container">
				<div className="flex">
					<label>
						سند مبنا<span className="text-danger">*</span>
					</label>
				</div>
				<input
					type="text"
					className="form-control"
					value={dataEntry?.name || ''}
					disabled
				/>
			</div>
			<div className="Field_Container">
				<div className="flex">
					<label>
						نوع کالا<span className="text-danger">*</span>
					</label>
				</div>
				<Select
					options={partTypeOptions}
					value={partTypeOptions.find(option => option.value === partType)}
					onChange={(selectedOption) => SetPartType(selectedOption.value)}
					inputId="type-select"
					className="vision-select-container"
					classNamePrefix="vision-select"
					isDisabled={!!id}
				/>
			</div>
			<div className="Field_Container">
				<div className="flex">
					<label>
						تاریخ انجام کار <span className="text-danger">*</span>
					</label>
				</div>
				<DatePicker
					value={date}
					onChange={(dateObj) =>	SetDate(dateObj?.format("YYYY/MM/DD"))}
					calendar={preferences.language === 'en_US' ? null : persian}
					locale={preferences.language === 'en_US' ? null : persian_fa}
					inputClass="date-picker"
					containerClassName="w-full"
					arrow={false}
					calendarPosition="bottom-right"
					hideOnScroll
					disabled={!!id}
				/>
			</div>
			<div className="Field_Container">
				<div className="flex">
					<label>توضیحات</label>
				</div>
				<textarea onChange={(e) => SetDescription(e.target.value)} rows="1" className="!transition-none !delay-0" disabled={!!id} value={description}></textarea>
			</div>
			<div className="Field_Container">
				<div className="flex">
					<label>
						 ضمیمه
					</label>
				</div>
				{!id ? (
					<Attachments  types={attachmentDrop} single={false} onChange={(value) => HandleAttachment(value)}></Attachments>
				) : (
					attachments && attachments.length > 0 ? (
						<table className="w-full border border-gray-300 mt-2">
							<thead>
								<tr className="bg-gray-200">
									<th className="border p-2">نام فایل</th>
									<th className="border p-2">عملیات</th>
								</tr>
							</thead>
							<tbody>
								{attachments.map((attachment, index) => (
									<tr key={attachment.id || index}>
										<td className="border p-2">{attachment.document_name}</td>
										<td className="border p-2">
											<button 
												onClick={() => {
													const fileID = `${attachment.attachment}`;
													DownloadFileAPI(fileID).then(response =>
													{
														if (response && response.content)
														{
															DownloadByContent(response.content, response.name);
														}
													});
												}}
												className="btn secondary "
											>
												دانلود
											</button>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					) : (
						<div className="text-gray-500 p-2">هیچ فایل ضمیمه‌ای وجود ندارد</div>
					)
				)}
			</div>
			<div className="Field_Container"></div>
				<Modal
					handler={<></>}
					trigger={showAosProductModal}
					fallDown={hideAosProductModal}
					onClose={() => setAosProductModal(false)}
					title="جستجو محصولات"
				>
				<div className="flex">
					<label>
						نام یا کد محصول
					</label>
				</div>
				<input
					placeholder="حداقل سه کاراکتر وارد کنید ..."
					type="text"
					className="form-control mb-4"
					value={aosProductSearch || ''}
					onChange={(e) => handleLiveSearch(e.target.value)}
				/>
				<div class="max-h-[350px]">
					<table className="w-full border border-gray-300">
						<thead>
							<tr className="bg-gray-200">
								<th className="border p-2">نام اجرت و قطعه</th>
								<th className="border p-2">کد مشخصات فنی</th>
								<th className="border p-2">کد محصول</th>
								<th className="border p-2">عملیات</th>
							</tr>
						</thead>
						<tbody>
							{Array.isArray(aosProductSearchResult) ? (
								aosProductSearchResult.map((item, index) => (
									<tr key={item.id} className="border">
										<td className="border p-2">{item.name}</td>
										<td className="border p-2">{item.part_number}</td>
										<td className="border p-2">{item.properties_as}</td>
										<td className="border p-2">
											<button onClick={() => selectPartAos(index)} className="btn-primary">
													انتخاب
											</button>
										</td>
									</tr>
								))
							) : (
								''
							)}
						</tbody>
					</table>
				</div>
			</Modal>
			<div className="Field_Container">
				<div className="flex">
					{!id && (
						<button onClick={(e) => setAosProductModal(true)} type="button" className='btn btn-primary'>
							افزودن اجرت و قطعه
						</button>
					)}
					<button onClick={CalculatePolicies} type="button" className='btn btn-primary'>
						برآورد قیمت
					</button>
				</div>
			</div>
			{showPartsTable && (
				<div className="w-full">
					<table className="w-full border border-gray-300 mt-4">
						<thead>
							<tr className="bg-gray-200">
								<th className="border p-2">نام اجرت و قطعه</th>
								<th className="border p-2">کد محصول</th>
								<th className="border p-2">کد مشخصلات فنی</th>
								<th className="border p-2">تعداد</th>
								<th className="border p-2">قیمت مصرف کننده</th>
								<th className="border p-2">عملیات</th>
							</tr>
						</thead>
						<tbody>
							{selectedParts.map((item, idx) => (
								<tr key={item.id}>
									<td className="border p-2">{item.name}</td>
									<td className="border p-2">{item.part_number}</td>
									<td className="border p-2">{item.properties_as || '-'}</td>
									<td className="border p-2">
										<input
												type="number"
												className="border w-16 p-1"
												value={item.count}
												min={1}
												disabled={!!id}
												onChange={(e) => {
													const value = parseInt(e.target.value) || 1;
													setSelectedParts(prev =>
														prev.map((p, i) =>
															p.id === item.id ? { ...p, count: value } : p
														)
													);
											}}
										/>
									</td>
									<td className="border p-2"></td>
										<td className="border p-2">
												{!id && (
													<button
														onClick={() =>
															setSelectedParts(prev => prev.filter(p => p.id !== item.id))
														}
														className="text-red-500 hover:underline"
													>
														حذف
													</button>
												)}
										</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			)}
		</div>
	</>
}
export default CreateProduct_Request;